import { handleTileClick } from '../../utils/tiles'

const NewBrandMessage = (() => {
  const overlay = document.getElementById('new-brand-message')
  const pageContent = document.getElementById('page-container')
  const content = document.getElementById('js-new-brand-message__inner')
  const tiles = document.getElementById('js-new-brand-message__tiles')

  const closeOverlay = (e) => {
    if (overlay && pageContent && content && tiles) {
      // only close if overlay background clicked
      if (
        e.target.classList.contains('js-close-overlay') ||
        (!content.contains(e.target) && !tiles.contains(e.target))
      ) {
        overlay.remove()
        pageContent.classList.remove('_hidden')

        // remove ?ms-redirect from url on redirection
        const currentSearchUrl = window.location.search
        const url = new URL(window.location.href)
        const searchParams = new URLSearchParams(currentSearchUrl)
        searchParams.delete('ms-redirect')
        url.search = searchParams.toString()
        window.history.replaceState(null, null, url.href)
      }

      // if tiles clicked - redirect and close overlay
      if (tiles.contains(e.target)) {
        handleTileClick(e)
        overlay.remove()
        pageContent.classList.remove('_hidden')
      }
    }
  }

  const showMessageIfNeeded = () => {
    if (overlay && pageContent) {
      if (
        window.location.href.indexOf('ms-redirect') > -1 &&
        !document.cookie.split('; ').find((row) => row.startsWith('newBrandMessageShown'))
      ) {
        document.cookie = 'newBrandMessageShown=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; Secure'
        overlay.classList.remove('c-new-brand-message--hidden')
        pageContent.classList.add('_hidden')

        overlay.addEventListener('click', closeOverlay)
        overlay.addEventListener('keypress', closeOverlay)
      } else {
        overlay.remove()
      }
    }
  }

  return {
    init: () => {
      showMessageIfNeeded()
    },
  }
})()

export default NewBrandMessage
